// This is our source of truth for translation keys
const en = {
  translation: {
    // Common
    "welcome": "Welcome to our app",
    "language": "Language",
    "continue": "Continue",
    "or": "OR",
    "need_help": "Need Help?",
    "powered_by": "Powered By",
    "copyright": "Copyright",
    "header_logo": "Builder Logo",
    "try_again": "Try Again",
    "uh_oh": "Uh-Oh",
    "community": "Community",
    "accept": "Accept",
    
    // Languages
    "english": "English",
    "spanish": "Spanish",
    
    // Authentication
    "sign_in_with_phone": "Sign in with your phone number.",
    "need_account": "Need an account with NterNow?",
    "register_here": "Register here",
    "phone_placeholder": "000-000-0000",
    
    // Navigation
    "back": "Back",
    
    // Errors
    "phone_required": "Your phone number is required. Please re-enter it or sign up for an account.",
    "property_not_found_title": "Property not found",
    "property_unavailable_title": "Property unavailable",
    "tour_unavailable_title": "Tour unavailable",
    "session_expired_title": "Session expired",
    "tour_restart_needed_title": "Let's restart your tour",
    "temporary_problem_title": "Temporary problem",
    "refresh_needed_title": "Refresh needed",
    "something_went_wrong_title": "Something went wrong",
    "property_not_found_message": "This property couldn't be found or is no longer available.",
    "property_unavailable_message": "This property is not currently available for self-touring.",
    "tour_unavailable_message": "This tour cannot be started right now.",
    "identity_verification_required_message": "Identity verification is required before this tour can start.",
    "tour_location_not_confirmed_message": "We couldn't confirm your location for this tour. Please check location permissions or contact support.",
    "session_expired_message": "Your session has expired. Please try again.",
    "tour_restart_needed_message": "We couldn't continue the previous tour. Please choose another property or contact support.",
    "temporary_problem_message": "We couldn't load this property because of a temporary connection problem.",
    "refresh_needed_message": "We couldn't refresh the property information. Please try again.",
    "something_went_wrong_message": "Something went wrong while loading this property. Please try again.",
    "property_id_invalid_message": "The property identifier is invalid. Please check it and try again.",
    "access_problem_retry_help": "Try again if the problem is temporary, or choose another property.",
    "access_problem_terminal_help": "Please choose another property or contact support for help.",
    "no_active_lock": "We're sorry there is an issue getting access. There is no active lock on the property. Please call live support or try another property that is enabled for tours.",
    "access_issue": "We're sorry there is an issue getting access. {propStatusDescription}. Please call live support or try another property that is enabled for tours.",
    "accept_terms_error": "You must accept our terms and conditions to continue",
    
    // COVID Notice
    "covid_notice": "I understand that during the COVID-19 crisis, I am touring at my own risk and will ensure to follow the 5 CDC recommended guidelines when conducting a self-tour. For more information:",
    "covid_policy": "COVID-19 policy",
    
    // Property viewing
    "select_tour_date": "Select Tour Date",
    "previous_tours": "Previous Tours",
    "upcoming_tours": "Upcoming Tours",
    "choose_community": "Choose Community",
    "search_community": "Search Community",
    "book_a_tour": "Book a Tour",
    "tours": "Tours",
    "enter_property_id": "Enter Property ID",
    "property_id_placeholder": "Enter the 5 digit property ID on the door",
    "property_label": "Property",
    "explore_other_properties": "Explore other available properties",
    "find_other_properties": "Find other properties",
    
    // Account
    "edit_profile": "Edit Profile",
    "my_profile": "My Profile",
    "sign_in": "Sign In",
    "sign_out": "Sign Out",
    
    // Disclosure
    "disclosure_consent": "By selecting this box, I agree that I am 18 years or older and agree to be contacted by NterNow or the property owner or manager according to the",
    
    // Other pages
    "how_it_works": "How it Works",
    "feedback": "Feedback",
    "offer": "Offer",
    "help": "Help",
    "support": "Support",
    "privacy_policy": "Privacy Policy",
    "terms_legal": "Terms",
    "terms_of_service": "Terms of Service",
    "housing_opportunities": "Housing Opportunities",
    
    // Homepage
    "ready_tour": "Ready to tour?",
    "start_touring_button": "Start Touring Now"
  }
};

// Create types based on the English translations structure, but allow any string values
export type TranslationKeys = {
  [K in keyof typeof en.translation]: string;
};

export type TranslationResource = {
  translation: TranslationKeys;
};

export default en;
